import { render, staticRenderFns } from "./PostParamList.vue?vue&type=template&id=90e43d2e&scoped=true"
import script from "./PostParamList.vue?vue&type=script&lang=js"
export * from "./PostParamList.vue?vue&type=script&lang=js"
import style0 from "./PostParamList.vue?vue&type=style&index=0&id=90e43d2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e43d2e",
  null
  
)

export default component.exports